import React from 'react';
import NavBar from 'components/NavBar.jsx';

function Admin({ children }) {
  const navLinks = [
    {
      to: '/admin',
      activeClassName: 'active',
      linkText: 'Accounts',
    },
  ];

  return (
    <div>
      <NavBar navLinks={navLinks} />
      <div className="content-margin">{children}</div>
    </div>
  );
}

export default Admin;
